"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useRef, useState } from "react";
interface MemesQuickVoteDescriptionProps {
  readonly description: string;
}
export default function MemesQuickVoteDescription(t0) {
  const $ = _c(12);
  const {
    description
  } = t0;
  const [isExpanded, setIsExpanded] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const visibleDescriptionRef = useRef(null);
  const clampClass = isExpanded ? "tw-line-clamp-none" : "tw-line-clamp-1 md:tw-line-clamp-4";
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const visibleDescription = visibleDescriptionRef.current;
      if (!visibleDescription) {
        return;
      }
      const computedStyles = globalThis.getComputedStyle(visibleDescription);
      const lineHeight = Number.parseFloat(computedStyles.lineHeight || "0");
      const collapsedLineCount = globalThis.matchMedia("(min-width: 768px)").matches ? 4 : 1;
      const collapsedHeight = lineHeight * collapsedLineCount;
      if (!Number.isFinite(collapsedHeight) || collapsedHeight <= 0) {
        return;
      }
      const previousDisplay = visibleDescription.style.display;
      const previousOverflow = visibleDescription.style.overflow;
      const previousWebkitLineClamp = visibleDescription.style.webkitLineClamp;
      visibleDescription.style.display = "block";
      visibleDescription.style.overflow = "visible";
      visibleDescription.style.webkitLineClamp = "unset";
      const fullHeight = visibleDescription.getBoundingClientRect().height;
      visibleDescription.style.display = previousDisplay;
      visibleDescription.style.overflow = previousOverflow;
      visibleDescription.style.webkitLineClamp = previousWebkitLineClamp;
      const nextIsOverflowing = fullHeight > collapsedHeight + 1;
      setIsOverflowing(current => current === nextIsOverflowing ? current : nextIsOverflowing);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const measureOverflow = t1;
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const frameId = globalThis.requestAnimationFrame(() => {
        measureOverflow();
      });
      if (typeof ResizeObserver === "undefined") {
        const handleResize = () => {
          measureOverflow();
        };
        globalThis.addEventListener("resize", handleResize);
        return () => {
          globalThis.removeEventListener("resize", handleResize);
          globalThis.cancelAnimationFrame(frameId);
        };
      }
      const observer = new ResizeObserver(() => {
        measureOverflow();
      });
      if (visibleDescriptionRef.current) {
        observer.observe(visibleDescriptionRef.current);
      }
      return () => {
        observer.disconnect();
        globalThis.cancelAnimationFrame(frameId);
      };
    };
    t3 = [measureOverflow];
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  const t4 = `${"tw-mb-0 tw-whitespace-pre-line tw-text-sm tw-font-medium tw-leading-relaxed tw-text-iron-400 md:tw-text-md"} ${clampClass}`;
  let t5;
  if ($[3] !== description || $[4] !== t4) {
    t5 = <p ref={visibleDescriptionRef} className={t4}>{description}</p>;
    $[3] = description;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== isExpanded || $[7] !== isOverflowing) {
    t6 = isOverflowing && <button type="button" aria-expanded={isExpanded} onClick={() => {
      setIsExpanded(_temp);
    }} className="tw-inline-flex tw-w-fit tw-border-0 tw-bg-transparent tw-px-0 tw-py-1 tw-text-xs tw-font-medium tw-leading-none tw-text-iron-500 tw-transition-colors tw-duration-200 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-white/15 desktop-hover:hover:tw-text-iron-300">{isExpanded ? "See less" : "See more"}</button>;
    $[6] = isExpanded;
    $[7] = isOverflowing;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t5 || $[10] !== t6) {
    t7 = <div className="tw-space-y-1.5">{t5}{t6}</div>;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
}
function _temp(current_0) {
  return !current_0;
}